import Vue from 'vue';
// DataV 组件库 按需引入
import {
  loading,
  decoration10,
  decoration8,
  decoration6,
  borderBox9,
  borderBox10,
  scrollBoard,
} from '@jiaminghi/data-view';

Vue.use(loading);
Vue.use(decoration10);
Vue.use(decoration8);
Vue.use(decoration6);
Vue.use(borderBox9);
Vue.use(borderBox10);
Vue.use(scrollBoard);
